import { FacebookProvider, LoginButton } from 'react-facebook'
import { FACEBOOK_APP_ID } from 'src/common/constants'

type FacebookLoginProps = {
    onSuccess: (fbResponse: any) => void
    onError: (e: any) => void
}

export const FacebookLogin = ({ onError, onSuccess }: FacebookLoginProps) => {
    return (
        <FacebookProvider appId={FACEBOOK_APP_ID}>
            <LoginButton
                scope="user_friends,email,public_profile"
                onCompleted={onSuccess}
                onError={onError}
                className="relative inline-flex items-center justify-center w-full px-4 py-4 text-base font-medium text-white transition-all duration-200 bg-[#4267B2] rounded-md hover:bg-blue-800 focus:bg-blue-800 hover:text-white focus:text-white focus:outline-none"
            >
                <i className="fab fa-facebook-f text-xl mr-2"></i>
                <span>Login with Facebook</span>
            </LoginButton>
        </FacebookProvider>
    )
}
